function instanceOfGrid(object) {
  return "items" in object;
}
export {
  instanceOfGrid
};
